import { translate } from "@jsverse/transloco";

export function getPhysicalContextLabel(key: string): string {
  const translationKey = `physical_context_label.${key}`;
  const translated = translate(translationKey);
  // If translation returns the key itself (not found), return the original key
  return translated === translationKey ? key : translated;
}

